import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import "react-resizable/css/styles.css";
import withStyles from "components/with-styles";
import styles from "./styles/timeline-segment-dialog.css.js";
import Dialog from "components/dialog";
import TimelineSegmentInputs from "./timeline-segment-inputs";
import Icon from "components/icon";
import Button from "components/buttons";
import { FormattedMessage } from "react-intl";

const TimelineSegmentDialog = ({
  open,
  setOpen,
  element,
  onDelete,
  period,
  segment,
  disabled = false,
  onChange,
  classes,
}) => {
  const [segmentValue, setSegmentValue] = useState(segment);

  const handleCloseDialog = useCallback(
    e => {
      e.stopPropagation();
      setOpen(false);
    },
    [setOpen],
  );

  const handleAcceptDialog = useCallback(
    e => {
      e.stopPropagation();
      onChange(segmentValue);
      setOpen(false);
    },
    [onChange, segmentValue, setOpen],
  );

  return disabled ? null : (
    <Dialog
      paperProps={{
        onClick: e => {
          e.preventDefault();
          e.stopPropagation();
        },
      }}
      open={open}
      showModalAccept
      showModalClose={false}
      showModalCloseCross
      onClose={handleCloseDialog}
      onAccept={handleAcceptDialog}
    >
      <TimelineSegmentInputs element={element} segment={segmentValue} period={period} onChange={setSegmentValue} />
      {element.segments.length > 1 && (
        <div className={classes.dialog_container}>
          <Button onClick={e => onDelete(segment)} variant="outlined" size="small">
            <Icon name="delete" className={classes.dialog_addButton_icon} />
            <FormattedMessage id="common.delete" />
          </Button>
        </div>
      )}
    </Dialog>
  );
};

TimelineSegmentDialog.propTypes = {
  /*
   * Elemento a representar en el timeline
   */
  element: PropTypes.shape({
    layoutId: PropTypes.string.isRequired,
    showAlways: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        start: PropTypes.number,
        end: PropTypes.number,
      }),
    ),
  }),
  /*
   * Segmento a representar en el componente
   */
  segment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    start: PropTypes.number,
    end: PropTypes.number,
  }),
  /*
   * Indica si está deshabilitado
   */
  disabled: PropTypes.bool,
  /*
   * Callback que se llama con el segmento a borrar
   */
  onDelete: PropTypes.func,
  /*
   * Callback que se llama con el segmento actualizado
   */
  onChange: PropTypes.func,
  /*
   * Período que representa el timeline (en segundos)
   */
  period: PropTypes.number,
  /*
   * Indica si está abierto
   */
  open: PropTypes.bool,
  /*
   * Cambia el estado de apertura del diálogo
   */
  setOpen: PropTypes.func,
};

export default withStyles(styles)(TimelineSegmentDialog);
